import { render, staticRenderFns } from "./waitPostbackAgreementList.vue?vue&type=template&id=2d280585&scoped=true"
import script from "./waitPostbackAgreementList.vue?vue&type=script&lang=js"
export * from "./waitPostbackAgreementList.vue?vue&type=script&lang=js"
import style0 from "./waitPostbackAgreementList.vue?vue&type=style&index=0&id=2d280585&prod&lang=scss&scoped=true"
import style1 from "./waitPostbackAgreementList.vue?vue&type=style&index=1&id=2d280585&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d280585",
  null
  
)

export default component.exports